import React, { useContext } from 'react';

interface ConfigContextShape {
  locale: string;
  lang?: string;
}

export const defaultContextValue: ConfigContextShape = {
  locale: '',
};

const ConfigContext = React.createContext<ConfigContextShape>(defaultContextValue);
ConfigContext.displayName = 'ConfigContext';

const useConfigContext = () => useContext(ConfigContext);

export { ConfigContext, ConfigContextShape, useConfigContext };
